<template>
    <div>
        <!-- <button @click.prevent="changeLocale(otherLocale)" class="lang-btn ar">{{ otherLangText }}</button> -->
        <a :href="getURL()" class="lang-btn ar">{{ otherLangText }}</a>
    </div>
</template>

<script>
    export default {
        methods:{
            changeLocale(locale) {
                // localStorage.language = locale
                this.$i18n.locale = locale
                this.$router.push({
                    params: {lang: locale}
                })
                this.$router.go()
            },
            getURL(){
                var path = "../";
                if(this.$router.currentRoute.meta.parent=="governance" || this.$router.currentRoute.meta.parent=="financial" || this.$router.currentRoute.meta.url=="world-of-zain/middleeast" || this.$router.currentRoute.meta.url=="world-of-zain/africa"){
                    path = "../../"
                }
                return this.$i18n.locale === 'en' ? path + 'ar/' + this.$router.currentRoute.meta.url : path + 'en/' + this.$router.currentRoute.meta.url
            }
        },
        computed:{
            otherLangText() {
                return this.$i18n.locale === 'ar' ? 'English' : 'العربية'
            },
            otherLocale() {
                return this.$i18n.locale === 'en' ? 'ar' : 'en'
            },
        }
    }
</script>

<style lang="scss" scoped>
    .lang-btn{
        color:#fff !important;
        text-decoration:none !important;
        font-size:rem(20px);
        background:none;
        border:0px;
        padding:0;
        &:hover{
            opacity:.7 !important;
        }
    }
</style>